import styled from 'styled-components'

import { useAppConfig } from '../../hooks/useAppConfig'
import { BriqTheme } from '../theme'

type IconProps = { color?: string; fontSize?: string; size?: { width?: string; height?: string } }

type Props = {
  type: string
  onClick?: () => void
} & IconProps

export function asStyledIcon(iconComponent: React.ComponentType<Omit<IconProps, 'size'>>) {
  return styled(iconComponent)`
    // @ts-ignore
    color: ${({ color, theme }) => theme.colors[(color as keyof BriqTheme['colors']) || 'primary']};
    ${({ fontSize }) =>
      fontSize &&
      `
      font-size: ${fontSize};
    `}
  `
}

export const Icon = ({ type, size = {}, ...rest }: Props) => {
  const { icons } = useAppConfig()
  // @ts-ignore
  const Component = icons[type]
  if (Component) return <Component {...rest} {...size} />
  return null
}
